export enum EAllowedDateDirection {
	PAST = 'past',
	FUTURE = 'future',
	ALL = 'all',
}

export interface IDateRangeProps {
	allowedDateDirection?: EAllowedDateDirection;
	startDate: Date | null;
	endDate: Date | null;
	setStartDate: (date: Date | null) => void;
	setEndDate: (date: Date | null) => void;
}
